export default "__VITE_ASSET__b0f86ece__"